/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommonErrorDef { 
    args?: Array<string>;
    /**
     * Count of number of occurrences of the error
     */
    count?: number;
    error_code?: string;
    error_message?: string;
    /**
     * Time at which the latest Error was encountered
     */
    final_time_stamp?: Date;
    help_info?: Array<string>;
    /**
     * Time at which the first Error was encountered
     */
    initial_time_stamp?: Date;
    span_id?: string;
    trace_id?: string;
}

